import { StatsigClient } from '@statsig/react-bindings';

export const RECAPTCHA_HARDENING_GATE = 'web-ordering-recaptcha-hardening';

export const isRecaptchaHardeningEnabled = () => {
  try {
    return StatsigClient.instance().checkGate(RECAPTCHA_HARDENING_GATE);
  } catch {
    return false;
  }
};
